import { useState } from "react";
import PageHero from "@/components/base/PageHero";
import NewsCard from "@/components/base/NewsCard";
import Pagination from "@/components/base/Pagination";
import { newsList } from "@/mocks/news";
import { useSeo } from "@/hooks/useSeo";

const PAGE_SIZE = 4;

export default function NewsPage() {
  useSeo({
    title: "最新影视资讯 - 年轻的母亲2资讯汇总",
    description:
      "《年轻的母亲2》最新影视资讯汇总，包含剧集动态、幕后花絮、角色分析与观众互动等内容，帮助观众及时了解剧集口碑与相关更新节奏。",
    keywords: "年轻的母亲2资讯,影视资讯,剧集动态,幕后花絮,角色分析",
  });

  const [page, setPage] = useState(1);
  const totalPages = Math.max(1, Math.ceil(newsList.length / PAGE_SIZE));
  const currentPage = Math.min(page, totalPages);
  const pageItems = newsList.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

  return (
    <div className="w-full">
      <PageHero
        eyebrow="资讯中心"
        title="最新影视资讯"
        desc="从口碑走势到幕后花絮，从角色研究到观众互动，这里汇总了《年轻的母亲2》相关的全部内容更新。"
        breadcrumb={[{ label: "首页", to: "/" }, { label: "影视资讯" }]}
      />

      <div className="mx-auto w-full px-4 py-8 md:px-6 md:py-10">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_280px]">
          <div>
            <p className="mb-4 text-sm text-foreground-600">
              共 {newsList.length} 篇资讯 · 第 {currentPage} / {totalPages} 页
            </p>
            <div className="flex flex-col gap-4">
              {pageItems.map((item) => (
                <NewsCard key={item.id} {...item} />
              ))}
            </div>
            <Pagination page={currentPage} totalPages={totalPages} onChange={setPage} />
          </div>

          <aside className="lg:sticky lg:top-24 lg:self-start">
            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <span className="flex h-5 w-5 items-center justify-center">
                  <i className="ri-list-check-2 text-lg"></i>
                </span>
                资讯分类
              </h2>
              <ul className="mt-4 flex flex-col gap-2">
                {["剧集动态", "幕后花絮", "角色分析", "观众互动"].map((cat) => (
                  <li key={cat}>
                    <span className="flex items-center justify-between rounded-md px-3 py-2 text-sm text-foreground-700">
                      <span className="flex items-center gap-2">
                        <span className="h-1.5 w-1.5 rounded-full bg-accent-500"></span>
                        {cat}
                      </span>
                      <span className="font-label text-xs text-foreground-400">
                        {newsList.filter((n) => n.category === cat).length}
                      </span>
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
}